import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { DriverPouchListedAdminDto } from '@/backend/market'
import { DriverPouchMiniEntity } from '../../domain/entities/DriverPouchMiniEntity'

export class DriverPouchMiniModel extends DriverPouchMiniEntity {
  constructor(dataDto: DriverPouchListedAdminDto) {
    super()
    mapEntityProperties<DriverPouchMiniModel>(this, dataDto)
  }
}
